<template>
  <form-field :attribute="attribute" type="select" :label="label" :required="required" :errorKeys="errorKeys">
    <select :multiple="multiple">
      <option value="" v-text="translations.formSelectPlaceholder"></option>
      <slot></slot>
    </select>
  </form-field>
</template>

<script>
import { REGISTRATION_UPDATE } from "../../store/types";
import ActsAsFormField from "../../mixins/ActsAsFormField";
import HasSelectizeInstance from "../../mixins/HasSelectizeInstance";
import HasTranslatedText from "../../mixins/HasTranslatedText";

export default {
  mixins: [ActsAsFormField, HasSelectizeInstance, HasTranslatedText],

  props: {
    create_other: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    limit: {
      type: Number,
      required: false,
      default: () => null,
    },
  },

  methods: {
    updateSelection() {
      const payload = { [this.attribute]: this.$selectize.getValue() };

      this.$store.commit(REGISTRATION_UPDATE, { payload });
    },
  },
};
</script>
